export function arrayRandomItem(array) {
    if (array.length === 0) {
        return null;
    }
    if (array.length === 1) {
        return array[0];
    }
    return array[Math.floor(Math.random() * array.length)]
}

export function arrayRandomItems(array, n) {
    if (array.length === 0 || n <= 0) {
        return [];
    }
    if (n >= array.length) {
        return [].concat(array);
    }
    return array
        .map(x => ({x: x, r: Math.random()}))
        .sort((a, b) => a.r - b.r)
        .map(a => a.x)
        .slice(0, n);
}

export function arrayContainsP(array, predicate) {
    for (let i = 0; i < array.length; ++i) {
        if (predicate(array[i])) {
            return true;
        }
    }
    return false;
}

export function arrayIndexOfP(array, predicate) {
    let i = 0;
    for (; i < array.length; ++i) {
        if (predicate(array[i])) {
            break;
        }
    }
    return i;
}

export function arrayLastIndexOfP(array, predicate) {
    let i = array.length - 1;
    for (; i >= 0; --i) {
        if (predicate(array[i])) {
            return i;
        }
    }
    return -1;
}